import { IconName, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { ChangeDetectionStrategy, Component, Input, EventEmitter, Output } from '@angular/core';

export class HeaderButton {
  text?: string;
  icon?: IconName;
  func: VoidFunction;
  color?: string = 'primary'
}

@Component({
  selector: 'tcc-mono-details-card-layout',
  templateUrl: './details-card-layout.component.html',
  styleUrls: ['./details-card-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetailsCardLayoutComponent {
  @Input() public iconName: IconName;
  @Input() public title: string;
  @Input() public displayActions: boolean = true;
  @Input() public displayMenu: boolean = false;
  @Input() public displayEdit: boolean = true;
  @Input() public displayAdd: boolean = false;
  @Input() public displayDelete: boolean = true;
  @Input() public buttonFill: 'clear' | 'default' | 'outline' | 'solid' | undefined = 'solid';
  @Input() public buttonSize: SizeProp = 'lg';
  @Input() public cardId: number = 1;
  @Input() public headerTextColor: string = 'medium';
  @Input() public buttons: HeaderButton[];

  @Output() public onAdd = new EventEmitter();
  @Output() public onEdit = new EventEmitter();
  @Output() public onDelete = new EventEmitter();

  protected edit(): void {
    this.onEdit.emit();
  }

  protected delete(): void {
    this.onDelete.emit();
  }

  protected add(): void {
    this.onAdd.emit();
  }
}
